import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheLeavePremissionRetrieveActions,
  SetTheLeavePremissionEditsActions,
    setTablePositionPersist

} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import "../../../StyleSheet/MainComponent/LeavePermission/LeavePermission.scss";
import { data } from "jquery";
const LeavePermissionEdit = (props) => {
  const { currentPage, setShow, show, EditId, selectVal , white_collar ,from_date , to_date , search,
    DatasFilters , clientFilter,
    selectValgetfilter
  } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
      const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );

  const [descpErr, setdeserr] = useState("");
  const initialState = {
    from_date: "",
    to_date: "",
    continue_leave: "",
    status: "",
    notes: "",

    user_id: "",
    leave_type: "",
    certificate_id: "",
    client_id: "",
    user_name: "",
    description: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  useEffect(() => {
    dispatch(SetTheLeavePremissionRetrieveActions({ EditId }));
  }, []);
   
   
  useEffect(() => {
    var LeaveType = "";
    console.log(state.LeavePermissionRetrieveCall.LeaveRetrieveStatus, "datas");
    if (
      state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.leave_type !=
        undefined &&
      state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.leave_type
        .leave_type != undefined &&
      state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.leave_type
        .leave_type != null
    ) {
      LeaveType =
        state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.leave_type
          .leave_type;
    }
    if (state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.id != undefined) {
      const dateString =
        state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,
        leave_type: LeaveType,
        status: state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.status,
        from_date:
          state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.from_date,
        to_date: state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.to_date,
        notes: state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.notes,
        user_name:
          state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.user_id
            .first_name,
        client_id:
          state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.client_id !=
          null
            ? state.LeavePermissionRetrieveCall.LeaveRetrieveStatus.client_id
                .client_name
            : "",
        description:
          state.LeavePermissionRetrieveCall.LeaveRetrieveStatus
            .reason_for_decline,
      });
    }
  }, [state.LeavePermissionRetrieveCall.LeaveRetrieveStatus]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
    setdeserr("");
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {
       const newEntry = { isApproved: true };
    const result = { ...TablePositionPersist.LeaveRequestPageViews, ...newEntry };
    dispatch(
      setTablePositionPersist({
        data: result,
        pageName: "LeaveRequestPageViews",
      })
    ); 


    const payload = {
      status: Data.status.toLowerCase(),
      // description: Data.description,
      description:
        Data.status.toLowerCase() == "decline" ? Data.description : "",
      EditId: EditId,
      // currentPage: currentPage,
      // selectVal: selectVal,
      // white_collar:white_collar,
      // from_date:from_date, 
      // to_date:to_date, 
      // search:search,


      GetlistOptoins:{
        search: search,
        page_size: 20,
        page: currentPage,
        status: selectValgetfilter,
        white_collar: white_collar,
        from_date: from_date,
        to_date: to_date,
    state:DatasFilters.state,
    region:DatasFilters.region,
    zone:DatasFilters.zone,
    client:clientFilter.Client,
      }
    };
    dispatch(SetTheLeavePremissionEditsActions(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Employee leave Request </span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Note
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.notes}
                            readOnly
                          />
                        </div>
                       <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Leave Type
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.leave_type}
                            readOnly
                          />
                        </div>
                        <div className="col-sm-3">
                          <div className="row">
                            <div
                              className="col-12"
                              style={{ marginTop: "15px" }}
                            >
                              <label
                                for="validationCustom01"
                                class="form-label-Header"
                              >
                                Leave
                              </label>
                            </div>
                            <div className="row" style={{ marginLeft: "5px" , marginRight:"3px" }}>
                              <div className="col">
                                <label
                                  for="validationCustom01"
                                  class="form-label"
                                >
                                  From
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="name"
                                  value={Data.from_date}
                                  readOnly
                                />
                              </div>
                              {Data.to_date != undefined &&
                              Data.to_date != "" ? (
                                <div className="col">
                                  <label
                                    for="validationCustom01"
                                    class="form-label"
                                  >
                                    To
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="validationCustom01"
                                    autocomplete="off"
                                    name="name"
                                    value={Data.to_date}
                                    readOnly
                                  />
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3 mt-3">
                       <br/>
                          <label for="validationCustom01" class="form-label">
                            Client name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.client_id}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <br/>
                           
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>
                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>

                      {Data.status.toLowerCase() == "decline" ? (
                        <>
                          <div
                            className="col-sm-3 mt-3"
                            style={{ width: "700px" }}
                          >
                            <br/>
                                                        <label for="validationCustom01" class="form-label">
                              Reason for decline
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                            />
                            <p style={{ color: "red" }}>{descpErr}</p>
                          </div>
                        </>
                      ) : null}
                      </div>

                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.LeavePermissionRetrieveCall.LeaveRetrieveStatus
                            .status == Data.status.toLowerCase()
                        }
                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeavePermissionEdit;
